import { type FC, type MouseEvent, useState } from "react";
import { Button, ListItemIcon, ListItemText, Menu, MenuItem, Paper, Stack, Typography } from "@mui/material";
import SelectAllIcon from "@mui/icons-material/SelectAll";
import DeselectIcon from "@mui/icons-material/Deselect";
import MailOutlineIcon from "@mui/icons-material/MailOutlined";

interface Props {
  selectedCount: number;
  allSelected: boolean;
  selectable: boolean;
  onToggleAll: () => void;
  onClear: () => void;
  onOpenMassMessage: () => void;
}

const ClientSelectionToolbar: FC<Props> = ({
  selectedCount,
  allSelected,
  selectable,
  onToggleAll,
  onClear,
  onOpenMassMessage,
}) => {
  const [actionsAnchor, setActionsAnchor] = useState<HTMLElement | null>(null);

  const openMassMessage = () => {
    setActionsAnchor(null);
    onOpenMassMessage();
  };

  return (
    <Paper
      elevation={0}
      sx={{
        mb: 2,
        px: 2,
        py: 1.25,
        border: "1px solid rgba(0,0,0,0.08)",
        borderRadius: 2,
        display: "flex",
        flexWrap: "wrap",
        gap: 1,
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Stack direction="row" spacing={1} sx={{ alignItems: "center", flexWrap: "wrap" }}>
        <Typography variant="body2" color="text.secondary">
          Zaznaczone: <strong>{selectedCount}</strong>
        </Typography>
        <Button size="small" startIcon={<SelectAllIcon />} onClick={onToggleAll} disabled={!selectable}>
          {allSelected ? "Odznacz wszystkich" : "Zaznacz wszystkich"}
        </Button>
        {selectedCount > 0 && (
          <Button size="small" color="inherit" startIcon={<DeselectIcon />} onClick={onClear}>
            Wyczyść zaznaczenie
          </Button>
        )}
      </Stack>
      <Button
        size="small"
        variant="outlined"
        disabled={!selectedCount}
        onClick={(event: MouseEvent<HTMLButtonElement>) => setActionsAnchor(event.currentTarget)}
      >
        Funkcje masowe
      </Button>
      <Menu anchorEl={actionsAnchor} open={Boolean(actionsAnchor)} onClose={() => setActionsAnchor(null)}>
        <MenuItem onClick={openMassMessage}>
          <ListItemIcon>
            <MailOutlineIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Wyślij mail / SMS" secondary="SMSTravel360 / Brevo" />
        </MenuItem>
      </Menu>
    </Paper>
  );
};

export default ClientSelectionToolbar;
